import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import {
  API_URL,
  DEFAULT_USER_IMG_URL,
  NEW_API_URL,
} from "../../constants/Globals";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Loader from "../Loader";

var moment = require("moment-timezone");

export class AiDebates extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sdLoading: false,
      loading: false,
      pageNumber: 1,
      suggestedCategories: null,
      allCategories: [],
      categoryId: "all",
      loadedSuggestedDebates: [],
      allSuggestedDebates: [],
      noMoreDebates: false,
      brandAccount: null,
      aiContentGroups: {},
      alertMessage: "",
      showLoader: 0,
      isBrandAccSet: false,
    };
  }

  getSuggestedDebates = () => {
    console.log("getSuggestedDebates >>>");
    const { categoryId, pageNumber, allSuggestedDebates } = this.state;
    console.log("categoryId", categoryId, pageNumber);
    const { selNetworkId, type = "default" } = this.props;

    if (!!selNetworkId) {
      let queryParams = `?perPage=400&pageNumber=${pageNumber}&clientId=${selNetworkId}`;

      if (!!categoryId) {
        queryParams += `&categoryId=${categoryId}`;
      }

      queryParams += `&debateStatus=1`;
      console.log("queryParams", queryParams);

      axios.get(`${NEW_API_URL}/ai-feeds${queryParams}`).then(({ data }) => {
        const { loadedSuggestedDebates } = this.state;

        const debates = data.data;

        console.log("categoryId", categoryId);
        const debatesByCategory = debates;
        const newCollection = loadedSuggestedDebates.concat(debates);
        const newAiContentGroups = {};

        debates.forEach((debate) => {
          if (debate.isAi && debate.articleSourceId) {
            if (!newAiContentGroups[debate.articleSourceId]) {
              newAiContentGroups[debate.articleSourceId] = {
                id: debate.articleSourceId,
                activePoll: debate.id,
                polls: [debate.id],
              };
            } else {
              newAiContentGroups[debate.articleSourceId].polls.push(debate.id);
            }
          }
        });

        this.setState({
          loadedSuggestedDebates: debatesByCategory,
          allSuggestedDebates:
            categoryId === "all" ? newCollection : allSuggestedDebates,
          aiContentGroups: newAiContentGroups,
          sdLoading: false,
        });
      });
    }
  };

  fetchBrandAccountDetail = async (clientIdAttr) => {
    await this.setState({
      loading: true,
    });

    await axios
      .get(
        API_URL +
          "/admin/brandAccount/" +
          this.props.selNetworkId +
          "?isSidedUserWhenNoBrandAccUser=1"
      )
      .then((res) => {
        if (res.data.data) {
          this.setState({ brandAccount: res.data.data });
        } else {
          this.setState({ brandAccount: this.props.loggedInUser });
        }
      });
  };

  suggestedCategorySelectHandler = async (categoryId) => {
    console.log("categoryId", categoryId);
    await this.setState({
      categoryId: categoryId,
      pageNumber: 1,
      loadedSuggestedDebates: [],
      noMoreDebates: false,
    });
    this.getSuggestedDebates();
  };

  getSuggestedCategories = () =>
    axios
      .get(
        `${API_URL}/categories?type=&hasDebates=true&clientId=${this.props.selNetworkId}`
      )
      .then(({ data }) => {
        this.setState({ allCategories: data.data });
      });

  getFilteredAndSortedCategories = () => {
    const { allCategories, allSuggestedDebates, loadedSuggestedDebates } =
      this.state;

    const debates = (allSuggestedDebates && allSuggestedDebates.length)
      ? allSuggestedDebates
      : loadedSuggestedDebates;

    if (!allCategories || allCategories.length === 0) return [];
    if (!debates || debates.length === 0) return [];

    const filtered = allCategories.filter((cat) =>
      debates.some((poll) => {
        const categoryId = poll.categories?.[0]?.categoryId || poll.categoryId;
        return categoryId === cat.id && poll.isAiTesting === 1;
      })
    );

    return filtered.sort((a, b) => a.text.localeCompare(b.text));
  };

  componentDidMount() {
    this.setState({
      loadedSuggestedDebates: [],
      sdLoading: false,
    });
    this.getSuggestedDebates();

    if (this.props.selNetworkId) {
      this.getSuggestedCategories();
      this.fetchBrandAccountDetail();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selNetworkId !== this.props.selNetworkId) {
      this.getSuggestedCategories();
      this.getSuggestedDebates();
      this.setState({
        loadedSuggestedDebates: [],
        sdLoading: false,
      });

      this.fetchBrandAccountDetail();
    }
    if (
      prevState.loadedSuggestedDebates === this.state.loadedSuggestedDebates &&
      this.props.suggestedDebates === ""
    ) {
    }
    if (prevProps.suggestedDebates !== this.props.suggestedDebates) {
      this.setState({
        loadedSuggestedDebates: this.state.loadedSuggestedDebates
          ? this.state.loadedSuggestedDebates.concat(
              this.props.suggestedDebates
            )
          : this.props.suggestedDebates,
        sdLoading: false,
      });
    }
  }

  suggestedDebatesScroll = async (e) => {
    /*var scrolled = this.loadingRef.scrollLeft + this.loadingRef.offsetWidth;
		var totalScroll = this.loadingRef.scrollWidth;
		if(scrolled >= totalScroll && this.state.noMoreDebates === false){
			await this.setState({
				sdLoading: true,
				pageNumber: this.state.pageNumber + 1
			})
			this.getSuggestedDebates()
		}
		*/
  };

  displayAlert = async (alertMessage) => {
    this.setState({
      alertMessage,
    });

    setTimeout(() => {
      this.setState({
        alertMessage: "",
      });
    }, 2500);
  };

  handleChoosePoll = async (poll) => {
    try {
      await axios.post(`${NEW_API_URL}/choose-ai-debate-winner/${poll.id}`);
      this.displayAlert("Poll selected as winner for this article");
      this.getSuggestedDebates();
    } catch (err) {
      console.error("Error choosing poll:", err);
      this.displayAlert("Error selecting winner");
    }
  };

  handleRemovePoll = async (poll) => {
    try {
      await axios.post(`${NEW_API_URL}/delete-ai-debate/${poll.id}`);
      this.displayAlert("Poll removed from article");
      this.getSuggestedDebates();
    } catch (err) {
      console.error("Error removing poll:", err);
      this.displayAlert("Error removing poll");
    }
  };

  handleRegeneratePolls = async (poll) => {
    try {
      await axios.post(
        `${NEW_API_URL}/delete-debates-by-article-source/${poll.articleSourceId}`
      );

      const reqBody = {
        reqClientId: poll.articleSource.clientId,
        reqPageUrl: poll.articleSource.url,
        reqPageTitle: poll.articleSource.title,
        page: 1,
      };

      await axios.post(
        `${API_URL}/admin/debate/autoGenerateDebateForPage`,
        reqBody
      );

      this.displayAlert("New polls generated for this article");
      this.getSuggestedDebates();
    } catch (err) {
      console.error("Error regenerating polls:", err);
      this.displayAlert("Error regenerating polls");
    }
  };

  render() {
    const { selNetworkId, type = "default" } = this.props;
    const {
      loadedSuggestedDebates,
      allSuggestedDebates,
      brandAccount,
      aiContentGroups,
      showLoader,
    } = this.state;
    const suggestedCategoriesComputed = this.getFilteredAndSortedCategories();
    const kTrans = this.props.t ? this.props.t : "";
    return (
      <>
        <div className="suggestedDebatesSection mb-5 mt-2 common-form">
          <div className="joinedNetworksWrap">
            {/* ALL option */}
            <label className="sub-label">
              <input
                type="radio"
                name="category"
                checked={this.state.categoryId === "all"}
                onClick={() => this.suggestedCategorySelectHandler("all")}
                onChange={() => {}}
              />
              <span className="joinedNetworks">{kTrans("All")}</span>
            </label>

            {/* category options */}
            {suggestedCategoriesComputed?.map((cat) => (
              <label key={cat.id} className="sub-label position-relative">
                <input
                  type="radio"
                  name="category"
                  checked={this.state.categoryId === cat.id}
                  onClick={() => this.suggestedCategorySelectHandler(cat.id)}
                  onChange={() => {}}
                />
                <span className="joinedNetworks">{cat.text}</span>
              </label>
            ))}
          </div>
          <div className="topDebatesContentWrapper">
            <div
              className="topDebatesContent mt-3"
              ref={(input) => (this.loadingRef = input)}
              onScroll={this.suggestedDebatesScroll}
            >
              {loadedSuggestedDebates && loadedSuggestedDebates.length ? (
                loadedSuggestedDebates.map((el, i) => {
                  if (el.isAi) {
                    if (el.isAiTesting === 0) {
                      return null;
                    }

                    const aiContentGroup =
                      aiContentGroups[el.articleSourceId.toString()];

                    if (aiContentGroup && aiContentGroup.activePoll !== el.id) {
                      return null;
                    }
                  }

                  return (
                    <div className="topDebate relative" key={el.id}>
                      {el.id === showLoader ? <Loader absolute={true} /> : null}

                      <div className="debatePreviewSection1">
                        {el.articleSource ? (
                          <div className="article-source">
                            <div className="article-source-top">
                              <div className="article-source-label">
                                {el.isAiWinningPoll
                                  ? "Winner Selected"
                                  : `Progress: ${el.aiPollViewProgress}%`}
                              </div>
                              {Object.values(aiContentGroups)
                                .filter(
                                  (aiContentGroup) =>
                                    aiContentGroup.id === el.articleSourceId
                                )
                                .map((aiContentGroup) => (
                                  <div
                                    className="article-source-selector"
                                    key={aiContentGroup.id}
                                  >
                                    {aiContentGroup.polls.map(
                                      (aiContentGroupPoll, index) => (
                                        <span
                                          key={aiContentGroupPoll}
                                          className={
                                            aiContentGroupPoll ===
                                            aiContentGroup.activePoll
                                              ? "active"
                                              : ""
                                          }
                                          onClick={() => {
                                            aiContentGroups[
                                              aiContentGroup.id.toString()
                                            ].activePoll = aiContentGroupPoll;
                                            this.setState({ aiContentGroups });
                                          }}
                                        >
                                          Poll {index + 1}
                                        </span>
                                      )
                                    )}
                                  </div>
                                ))}
                            </div>
                            <div className="article-source-title">
                              {el.articleSource.title}
                            </div>
                            <a
                              href={el.articleSource.url}
                              className="article-source-link"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {el.articleSource.url}
                            </a>
                          </div>
                        ) : null}
                        <div className="debatePreviewInner">
                          <div className="debatePreviewHeader inline-content middle">
                            {brandAccount ? (
                              <div className="author">
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  className="small-dp user-color-green"
                                  href={"/" + brandAccount.username}
                                  tabIndex="0"
                                >
                                  <img
                                    style={{
                                      borderColor: brandAccount.statusColor,
                                    }}
                                    data-src=""
                                    src={
                                      brandAccount.avatarObject
                                        ? brandAccount.avatarObject.small
                                            .location
                                        : DEFAULT_USER_IMG_URL
                                    }
                                    alt={brandAccount.name}
                                    className="sidedLazyLoad img-circle avatar"
                                    onError={(e) => {
                                      e.target.src = DEFAULT_USER_IMG_URL;
                                    }}
                                  />
                                  {brandAccount.roles ? (
                                    <>
                                      {brandAccount.roles.length > 0 &&
                                      brandAccount.roles.find(
                                        (role) => role.name === "VERIFIED"
                                      ) ? (
                                        <FontAwesomeIcon
                                          style={{
                                            color: brandAccount.checkmarkColor,
                                          }}
                                          icon={faCheckCircle}
                                          className="procheckmark"
                                        />
                                      ) : null}
                                    </>
                                  ) : (
                                    <FontAwesomeIcon
                                      style={{
                                        color: brandAccount.checkmarkColor,
                                      }}
                                      icon={faCheckCircle}
                                      className="procheckmark"
                                    />
                                  )}
                                </a>
                                <div className="copy-wrap">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    className="authorname"
                                    href={"/" + brandAccount.username}
                                    tabIndex="0"
                                  >
                                    <h6>{brandAccount.name}</h6>
                                  </a>
                                  <span className="authorhandle">
                                    <span className="handler">
                                      {kTrans("Posted")}{" "}
                                      {moment(el.startedAt).format(
                                        "MMM DD, YYYY"
                                      )}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            ) : null}

                            <NavLink
                              exact
                              className="ms-2 publishButton"
                              to={`/debates/debate/${el.id}`}
                            >
                              {kTrans("Edit")}
                            </NavLink>
                          </div>
                          <div className="debatePreviewTitle mt-3">
                            {el.thesis !== "" ? (
                              <h5>{el.thesis}</h5>
                            ) : (
                              <>
                                <p></p>
                                <p></p>
                                <p></p>
                              </>
                            )}
                          </div>
                          {el.endedAt === null ? null : (
                            <span className="lightColorSpan mt-2 d-block">{`Poll ends in ${(Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") ? (Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") : ""}`}</span>
                          )}
                          {(() => {
                            const hasSideImage = el.sides?.some(
                              (s) =>
                                s.sideBackgroundImageObject &&
                                s.sideBackgroundImageObject.large
                            );

                            const getPercentage = (votes, total) =>
                              !total || total === 0
                                ? 0
                                : ((votes * 100) / total).toFixed(1);

                            const userVotedSideId = el.userVoteSideId || null;

                            return hasSideImage ? (
                              <div className="debatePreviewSides debatePreviewVotes mt-3">
                                {el.sides?.map((side) => {
                                  const percentage = getPercentage(
                                    side.votes,
                                    el.votes
                                  );
                                  const isUserChoice =
                                    side.id === userVotedSideId;

                                  return (
                                    <div
                                      key={side.id}
                                      className={`side vote-container ${isUserChoice ? "voted" : ""}`}
                                    >
                                      <div className="message vote-image-container">
                                        <img
                                          alt="side-img"
                                          src={
                                            side.sideBackgroundImageObject
                                              ?.large?.location ||
                                            "/images/image.png"
                                          }
                                        />
                                        <div className="vote-overlay">
                                          <div className="vote-text">
                                            {side.text}
                                          </div>
                                          <div className="vote-percentage">
                                            {percentage}%
                                          </div>
                                        </div>
                                      </div>

                                      {isUserChoice && (
                                        <div className="check-icon">
                                          <FontAwesomeIcon icon={faCheck} />
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div className="debatePreviewSides mt-3">
                                {el.sides?.map((side) => {
                                  const percentage = getPercentage(
                                    side.votes,
                                    el.votes
                                  );
                                  const isUserChoice =
                                    side.id === userVotedSideId;

                                  return (
                                    <div
                                      className={`side vote-bar-container ${
                                        isUserChoice ? "voted" : ""
                                      }`}
                                      key={side.id}
                                    >
                                      <div className="message position-relative">
                                        <div
                                          className="percentageBar"
                                          style={{
                                            width: `${percentage}%`,
                                            background: side.sideColor + "26",
                                          }}
                                        ></div>

                                        <div
                                          className="topDebateSides"
                                          style={{
                                            borderColor: side.sideColor,
                                            background: side.sideColor + "10",
                                          }}
                                        >
                                          {side.text}
                                        </div>

                                        <span className="votesPercentage">
                                          {percentage}%
                                        </span>

                                        {isUserChoice && (
                                          <div className="check-icon">
                                            <FontAwesomeIcon icon={faCheck} />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })()}

                          <div className="ai-polls-action">
                            {(() => {
                              const hasWinner =
                                loadedSuggestedDebates?.some(
                                  (deb) =>
                                    deb.articleSourceId ===
                                      el.articleSourceId && deb.isAiWinningPoll
                                ) || false;

                              if (hasWinner) {
                                if (el.isAiWinningPoll) {
                                  return (
                                    <>
                                      <span className="poll-status-text">
                                        This poll is active on the selected page
                                      </span>
                                      <span
                                        className="text-button"
                                        title="Generate new polls for this article"
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to regenerate new polls for this article?"
                                            )
                                          ) {
                                            this.handleRegeneratePolls(el);
                                          }
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_22714_461)">
                                            <path
                                              d="M0.593673 10.6248C0.249923 10.6052 -0.015702 10.3123 -7.69596e-05 9.96853L0.015548 9.65603C0.199142 5.99587 3.21867 3.12478 6.88274 3.12478H15.2577L13.0155 1.08572C12.7616 0.855248 12.7421 0.45681 12.9726 0.202904C13.203 -0.0510023 13.6015 -0.0705335 13.8554 0.159935L17.2929 3.28493C17.4218 3.40212 17.496 3.57009 17.496 3.74587C17.496 3.92165 17.4218 4.08962 17.2929 4.20681L13.8554 7.33181C13.6015 7.56228 13.203 7.54665 12.9726 7.28884C12.7421 7.03103 12.7577 6.6365 13.0155 6.40603L15.2577 4.37478H6.88274C3.88664 4.37478 1.41399 6.72634 1.26555 9.71853L1.24992 10.031C1.2343 10.3748 0.937423 10.6404 0.593673 10.6248ZM19.4062 9.37478C19.7499 9.3904 20.0155 9.68728 19.9999 10.031L19.9843 10.3435C19.8007 14.0037 16.7812 16.8748 13.1171 16.8748H4.74211L6.9843 18.9138C7.2382 19.1443 7.25774 19.5427 7.02727 19.7967C6.7968 20.0506 6.39836 20.0701 6.14445 19.8396L2.70695 16.7146C2.57805 16.5974 2.50383 16.4295 2.50383 16.2537C2.50383 16.0779 2.57805 15.9099 2.70695 15.7927L6.14445 12.6677C6.39836 12.4373 6.7968 12.4529 7.02727 12.7107C7.25774 12.9685 7.24211 13.3631 6.9843 13.5935L4.74211 15.6248H13.1171C16.1132 15.6248 18.5859 13.2732 18.7343 10.281L18.7499 9.96853C18.7655 9.62478 19.0624 9.35915 19.4062 9.37478Z"
                                              fill="#333333"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_22714_461">
                                              <rect
                                                width="20"
                                                height="20"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <span className="poll-status-text">
                                        This poll has been closed
                                      </span>
                                      <span
                                        className="text-button"
                                        title="Generate new polls for this article"
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to regenerate new polls for this article?"
                                            )
                                          ) {
                                            this.handleRegeneratePolls(el);
                                          }
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_22714_461)">
                                            <path
                                              d="M0.593673 10.6248C0.249923 10.6052 -0.015702 10.3123 -7.69596e-05 9.96853L0.015548 9.65603C0.199142 5.99587 3.21867 3.12478 6.88274 3.12478H15.2577L13.0155 1.08572C12.7616 0.855248 12.7421 0.45681 12.9726 0.202904C13.203 -0.0510023 13.6015 -0.0705335 13.8554 0.159935L17.2929 3.28493C17.4218 3.40212 17.496 3.57009 17.496 3.74587C17.496 3.92165 17.4218 4.08962 17.2929 4.20681L13.8554 7.33181C13.6015 7.56228 13.203 7.54665 12.9726 7.28884C12.7421 7.03103 12.7577 6.6365 13.0155 6.40603L15.2577 4.37478H6.88274C3.88664 4.37478 1.41399 6.72634 1.26555 9.71853L1.24992 10.031C1.2343 10.3748 0.937423 10.6404 0.593673 10.6248ZM19.4062 9.37478C19.7499 9.3904 20.0155 9.68728 19.9999 10.031L19.9843 10.3435C19.8007 14.0037 16.7812 16.8748 13.1171 16.8748H4.74211L6.9843 18.9138C7.2382 19.1443 7.25774 19.5427 7.02727 19.7967C6.7968 20.0506 6.39836 20.0701 6.14445 19.8396L2.70695 16.7146C2.57805 16.5974 2.50383 16.4295 2.50383 16.2537C2.50383 16.0779 2.57805 15.9099 2.70695 15.7927L6.14445 12.6677C6.39836 12.4373 6.7968 12.4529 7.02727 12.7107C7.25774 12.9685 7.24211 13.3631 6.9843 13.5935L4.74211 15.6248H13.1171C16.1132 15.6248 18.5859 13.2732 18.7343 10.281L18.7499 9.96853C18.7655 9.62478 19.0624 9.35915 19.4062 9.37478Z"
                                              fill="#333333"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_22714_461">
                                              <rect
                                                width="20"
                                                height="20"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                    </>
                                  );
                                }
                              } else {
                                return (
                                  <>
                                    <span
                                      className="text-button"
                                      title="Choose this poll for this article"
                                      onClick={() => {
                                        if (
                                          window.confirm(
                                            "Are you sure you want to choose this poll as the winner?"
                                          )
                                        ) {
                                          this.handleChoosePoll(el);
                                        }
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.2812 3.19553C11.418 2.69553 11.9336 2.40256 12.4336 2.53928C12.9336 2.676 13.2266 3.19163 13.0898 3.69163L12.9141 4.33225C12.6992 5.12131 12.3711 5.86741 11.9492 6.55491C11.8281 6.74631 11.8242 6.9885 11.9336 7.18772C12.043 7.38694 12.2539 7.50803 12.4805 7.50803H17.5C18.1914 7.50803 18.75 8.06663 18.75 8.75803C18.75 9.19944 18.5195 9.59006 18.1719 9.81272C17.8906 9.99241 17.8008 10.3557 17.9648 10.6448C18.0664 10.8244 18.125 11.0354 18.125 11.258C18.125 11.7424 17.8516 12.1604 17.4492 12.3713C17.2852 12.4573 17.1641 12.6096 17.125 12.7932C17.0859 12.9768 17.1289 13.1643 17.2422 13.3088C17.4062 13.5198 17.5039 13.7854 17.5039 14.0705C17.5039 14.6252 17.1445 15.0979 16.6406 15.258C16.3359 15.3557 16.1562 15.6721 16.2227 15.9846C16.2422 16.0705 16.25 16.1604 16.25 16.2541C16.25 16.9455 15.6914 17.5041 15 17.5041H11.5039C10.8867 17.5041 10.2852 17.3205 9.76953 16.9807L8.26562 15.9768C7.91406 15.7424 7.61719 15.4416 7.39062 15.094C7.19922 14.8049 6.8125 14.7268 6.52344 14.9143C6.23438 15.1018 6.15625 15.4924 6.34375 15.7815C6.66016 16.2619 7.07422 16.6838 7.57031 17.0158L9.07422 18.0198C9.79297 18.5002 10.6367 18.7541 11.5 18.7541H15C16.3789 18.7541 17.5 17.633 17.5 16.2541V16.2307C18.2461 15.7971 18.75 14.9924 18.75 14.0666C18.75 13.7268 18.6797 13.3987 18.5586 13.1018C19.0586 12.6448 19.375 11.9885 19.375 11.2541C19.375 11.0002 19.3359 10.7541 19.2656 10.5237C19.7188 10.0705 20 9.44553 20 8.75413C20 7.37522 18.8789 6.25413 17.5 6.25413H13.5312C13.7734 5.74241 13.9727 5.21116 14.1211 4.65647L14.2969 4.01585C14.6133 2.85178 13.9258 1.64866 12.7617 1.32835C11.5977 1.00803 10.3945 1.69944 10.0742 2.8635L9.89844 3.50413C9.55078 4.77756 8.74219 5.87913 7.625 6.59006L7.50391 6.66819C7.04297 6.96116 6.65625 7.33616 6.35156 7.76975C6.15234 8.051 6.22266 8.44163 6.50781 8.64085C6.79297 8.84006 7.17969 8.76975 7.37891 8.4846C7.58984 8.18381 7.85547 7.9221 8.17578 7.72288L8.29688 7.64475C9.67578 6.76975 10.6758 5.41038 11.1055 3.83616L11.2812 3.19553ZM1.25 8.75413H3.75V17.5041H1.25V8.75413ZM0 8.75413V17.5041C0 18.1955 0.558594 18.7541 1.25 18.7541H3.75C4.44141 18.7541 5 18.1955 5 17.5041V8.75413C5 8.06272 4.44141 7.50413 3.75 7.50413H1.25C0.558594 7.50413 0 8.06272 0 8.75413Z"
                                          fill="#333333"
                                        />
                                      </svg>
                                      {/* &nbsp;{el.totalVotes} */}
                                    </span>

                                    <span
                                      className="text-button"
                                      title="Remove this poll from the article"
                                      onClick={() => {
                                        if (
                                          window.confirm(
                                            "Are you sure you want to remove this poll?"
                                          )
                                        ) {
                                          this.handleRemovePoll(el);
                                        }
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.2812 16.8086C11.418 17.3086 11.9336 17.6016 12.4336 17.4648C12.9336 17.3281 13.2266 16.8125 13.0898 16.3125L12.9141 15.6719C12.6992 14.8828 12.3711 14.1367 11.9492 13.4492C11.8281 13.2578 11.8242 13.0156 11.9336 12.8164C12.043 12.6172 12.2539 12.4961 12.4805 12.4961H17.5C18.1914 12.4961 18.75 11.9375 18.75 11.2461C18.75 10.8047 18.5195 10.4141 18.1719 10.1914C17.8906 10.0117 17.8008 9.64844 17.9648 9.35938C18.0664 9.17969 18.125 8.96875 18.125 8.74609C18.125 8.26172 17.8516 7.84375 17.4492 7.63281C17.2852 7.54687 17.1641 7.39453 17.125 7.21094C17.0859 7.02734 17.1289 6.83984 17.2422 6.69531C17.4062 6.48437 17.5039 6.21875 17.5039 5.93359C17.5039 5.37891 17.1445 4.90625 16.6406 4.74609C16.3359 4.64844 16.1562 4.33203 16.2227 4.01953C16.2422 3.93359 16.25 3.84375 16.25 3.75C16.25 3.05859 15.6914 2.5 15 2.5H11.5039C10.8867 2.5 10.2852 2.68359 9.76953 3.02344L8.26562 4.02734C7.91406 4.26172 7.61719 4.5625 7.39062 4.91016C7.19922 5.19922 6.8125 5.27734 6.52344 5.08984C6.23438 4.90234 6.15625 4.51172 6.34375 4.22266C6.66016 3.74219 7.07422 3.32031 7.57031 2.98828L9.07422 1.98438C9.79297 1.50391 10.6367 1.25 11.5 1.25H15C16.3789 1.25 17.5 2.37109 17.5 3.75V3.77344C18.2461 4.20703 18.75 5.01172 18.75 5.9375C18.75 6.27734 18.6797 6.60547 18.5586 6.90234C19.0586 7.35938 19.375 8.01562 19.375 8.75C19.375 9.00391 19.3359 9.25 19.2656 9.48047C19.7188 9.93359 20 10.5586 20 11.25C20 12.6289 18.8789 13.75 17.5 13.75H13.5312C13.7734 14.2617 13.9727 14.793 14.1211 15.3477L14.2969 15.9883C14.6133 17.1523 13.9258 18.3555 12.7617 18.6758C11.5977 18.9961 10.3945 18.3047 10.0742 17.1406L9.89844 16.5C9.55078 15.2266 8.74219 14.125 7.625 13.4141L7.50391 13.3359C7.04297 13.043 6.65625 12.668 6.35156 12.2344C6.15234 11.9531 6.22266 11.5625 6.50781 11.3633C6.79297 11.1641 7.17969 11.2344 7.37891 11.5195C7.58984 11.8203 7.85547 12.082 8.17578 12.2812L8.29688 12.3594C9.67578 13.2344 10.6758 14.5938 11.1055 16.168L11.2812 16.8086ZM1.25 13.75H3.75V5H1.25V13.75ZM0 13.75V5C0 4.30859 0.558594 3.75 1.25 3.75H3.75C4.44141 3.75 5 4.30859 5 5V13.75C5 14.4414 4.44141 15 3.75 15H1.25C0.558594 15 0 14.4414 0 13.75Z"
                                          fill="#333333"
                                        />
                                      </svg>
                                      {/* &nbsp;{el.comments} */}
                                    </span>

                                    <span
                                      className="text-button"
                                      title="Generate new polls for this article"
                                      onClick={() => {
                                        if (
                                          window.confirm(
                                            "Are you sure you want to regenerate new polls for this article?"
                                          )
                                        ) {
                                          this.handleRegeneratePolls(el);
                                        }
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_22714_461)">
                                          <path
                                            d="M0.593673 10.6248C0.249923 10.6052 -0.015702 10.3123 -7.69596e-05 9.96853L0.015548 9.65603C0.199142 5.99587 3.21867 3.12478 6.88274 3.12478H15.2577L13.0155 1.08572C12.7616 0.855248 12.7421 0.45681 12.9726 0.202904C13.203 -0.0510023 13.6015 -0.0705335 13.8554 0.159935L17.2929 3.28493C17.4218 3.40212 17.496 3.57009 17.496 3.74587C17.496 3.92165 17.4218 4.08962 17.2929 4.20681L13.8554 7.33181C13.6015 7.56228 13.203 7.54665 12.9726 7.28884C12.7421 7.03103 12.7577 6.6365 13.0155 6.40603L15.2577 4.37478H6.88274C3.88664 4.37478 1.41399 6.72634 1.26555 9.71853L1.24992 10.031C1.2343 10.3748 0.937423 10.6404 0.593673 10.6248ZM19.4062 9.37478C19.7499 9.3904 20.0155 9.68728 19.9999 10.031L19.9843 10.3435C19.8007 14.0037 16.7812 16.8748 13.1171 16.8748H4.74211L6.9843 18.9138C7.2382 19.1443 7.25774 19.5427 7.02727 19.7967C6.7968 20.0506 6.39836 20.0701 6.14445 19.8396L2.70695 16.7146C2.57805 16.5974 2.50383 16.4295 2.50383 16.2537C2.50383 16.0779 2.57805 15.9099 2.70695 15.7927L6.14445 12.6677C6.39836 12.4373 6.7968 12.4529 7.02727 12.7107C7.25774 12.9685 7.24211 13.3631 6.9843 13.5935L4.74211 15.6248H13.1171C16.1132 15.6248 18.5859 13.2732 18.7343 10.281L18.7499 9.96853C18.7655 9.62478 19.0624 9.35915 19.4062 9.37478Z"
                                            fill="#333333"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_22714_461">
                                            <rect
                                              width="20"
                                              height="20"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      {/* &nbsp;{el.analyticEngagements} */}
                                    </span>
                                  </>
                                );
                              }
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <span>{kTrans("No suggested poll found")}</span>
              )}
            </div>

            {this.state.sdLoading ? (
              <div className="sdLoading">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : null}

            {this.state.alertMessage ? (
              <div className="success">{this.state.alertMessage}</div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
  loggedInUser: state.login.user,
});

const Extended = withTranslation()(AiDebates);
Extended.static = AiDebates.static;

export default connect(mapStateToProps)(Extended);
